import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import { AntecipationData, AntecipationQueryParams } from "../types";

export const antecipationService = {
  async getAntecipationData(
    params: AntecipationQueryParams
  ): Promise<ApiResponse<AntecipationData>> {
    return await apiClient.post<AntecipationData>(
      "/gestorAntecipacaoViz",
      params
    );
  },
};
